export type FundUsageModelFR = {
  pourcentageUsage: number;
  descriptionUsage: string;
};

export type FundUsageModel = {
  percentage: number;
  description: string;
};

export const translateFundUsageModel = (fu: FundUsageModelFR): FundUsageModel => {
  return {
    percentage: fu.pourcentageUsage,
    description: fu.descriptionUsage,
  };
};

export const translateFundUsageModelArray = (fuA: FundUsageModelFR[]): FundUsageModel[] => {
  return fuA.map(e => translateFundUsageModel(e));
};
